import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const LoginStatusValidation = z.object({
  value: z.boolean({ required_error: '[LoginStatus] value is required' }),
})

export class LoginStatus extends Model {
  static create({ value }: z.infer<typeof LoginStatusValidation>) {
    LoginStatusValidation.parse({ value })
    return new LoginStatus(value)
  }

  static logged() {
    return LoginStatus.create({ value: true })
  }

  static unlogged() {
    return LoginStatus.create({ value: false })
  }

  constructor(private readonly _value: boolean) {
    super()
  }

  isLogged() {
    return this._value === true
  }

  isUnlogged() {
    return this._value === false
  }
}
